import React, { useState} from 'react'
import Loader from "../../ui_library/ver_24.10/Loader/Loader.comp";
import AssessmentCreationView from "../../views/ver_24.10/AssessmentCreation/AssessmentCreation.view";


const CreateAssessment = () => {
    const [showLoader, setShowLoader] = useState(false);

    const data = {
    };

    const actions = {
    };

    const options = {
    };

    if (showLoader) {
        return <Loader />;
    }

    return (
        <>
            <div>
                <AssessmentCreationView data={data} actions={actions} options={options}/>
            </div>
        </>
    );
}

export default CreateAssessment;